import { render } from "./BlogHollywoodSmilePurpose.vue?vue&type=template&id=766363ce"
import script from "./BlogHollywoodSmilePurpose.vue?vue&type=script&lang=js"
export * from "./BlogHollywoodSmilePurpose.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__